import React from 'react';
// import { AuthProvider } from './contexts/AuthContext';
import AppRoutes from './routes';
import { SidebarProvider } from "./context/SidebarContext";
import ErrorBoundary from './components/ErrorBoundary';

const App = () => (
  // <AuthProvider>
  <ErrorBoundary>
    <SidebarProvider>
      <AppRoutes />
    </SidebarProvider>
  </ErrorBoundary>
  // </AuthProvider>
);

export default App;
